import * as React from "react"
import BaseController from '../base-controller';

// markup
class Index extends React.Component {
  render() {
    return (
        <BaseController>

        <section class="text-center">
                <div class="container pos-vertical-center">
                    <div class="row justify-content-center">
                        <div class="col-md-8 col-lg-6">
                            <h1>Contact us</h1>
                            <p class="lead">
                                Do you need support? We are happy to help you.
                            </p>
                        </div>
                    </div>
                </div>
          </section>


          <section class=" bg--secondary">
          <div class="container">
              <div class="row justify-content-center no-gutters">
                  <div class="col-md-10 col-lg-8">
                      <div class="boxed boxed--border">
                      <form class="text-left form-email row mx-0 " action="https://submit-form.com/gv1cAfyE">
                      
                      <div class="col-md-6">
                        <span>Name</span>
                        <input type="text" id="name" name="name" placeholder="Name" required="" class="validate-required"/>
                      </div>

                      <div class="col-md-6">
                        <span>Email</span>
                        <input type="email" id="email" name="email" placeholder="Email" required="" class="validate-required"/>
                      </div>

                      <div class="col-md-12">
                        <span>Message</span>
                        <textarea
                          id="message"
                          name="message"
                          placeholder="Message"
                          required=""
                          rows="5"
                          class="validate-required"
                        ></textarea>
                      </div>
                      <div class="col-md-12 boxed">
                        <button type="submit" class="btn btn--primary type--uppercase">Send</button>
                      </div>
                    </form>
                      </div>
                  </div>
              </div>
          </div>
      </section>
        </BaseController>
    )
  }
}

export default Index
